/* PCP — shipping-message currency localiser.
   Two jobs, both so the fee and the duty are written in ONE consistent currency style:
   1. .aaa-origin__fee[data-gbp]  — a £ flat rate; convert to the shopper's market currency
      via Shopify.currency.rate (live GBP -> market rate). GBP markets keep £.
   2. .aaa-origin__amt[data-amount] — a duty figure already in the shopper's currency
      (server-computed from the presentment price); just reformat it the same way.
   Both use Intl with a fixed 'en' locale, so a shopper sees e.g. "AED 161" for the fee AND
   "AED 56" for the duty — never "AED 161" next to "Dhs. 56". Shopify's own JS money formatter
   isn't exposed under Markets, which is why we standardise on Intl rather than the theme format.
   Estimates round up to a whole unit; checkout shows the exact figure. Re-runs on variant change
   and cart updates (debounced MutationObserver); idempotent. */
(function () {
  if (window.__aaaShipFeeInit) return;
  window.__aaaShipFeeInit = true;

  function format(amount, currency) {
    try {
      return new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol', // bare symbol ($ not A$/CA$), matching Shopify's display
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return amount + ' ' + currency;
    }
  }

  function eachNode(selector, fn) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i]);
  }

  function convert() {
    var C = window.Shopify && window.Shopify.currency;
    if (!C || !C.active) return;
    var cur = C.active;
    var rate = parseFloat(C.rate) || 1;

    // 1. Converted £ shipping fees — skip GBP markets (they keep the £ figure).
    if (cur !== 'GBP') {
      eachNode('.aaa-origin__fee[data-gbp]:not([data-aaa-fee-done])', function (el) {
        var gbp = parseFloat(el.getAttribute('data-gbp'));
        if (isNaN(gbp)) return;
        var prefix = el.getAttribute('data-prefix') || '';
        el.textContent = prefix + format(Math.ceil(gbp * rate), cur);
        el.setAttribute('data-aaa-fee-done', '1');
      });
    }

    // 2. Duty amounts (already in the active currency) — reformat to match the fees.
    eachNode('.aaa-origin__amt[data-amount]:not([data-aaa-amt-done])', function (el) {
      var amt = parseFloat(el.getAttribute('data-amount'));
      if (isNaN(amt)) return;
      el.textContent = format(amt, cur);
      el.setAttribute('data-aaa-amt-done', '1');
    });
  }

  convert();
  document.addEventListener('DOMContentLoaded', convert);

  var pending;
  var observer = new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(convert, 80);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
